import * as z from "zod";

// Common input for all analytics endpoints
// Frontend converts user's local timezone dates to UTC before sending
const MarketingAgentAnalyticsInputSchema_ = z.object({
  startDate: z.string(), // YYYY-MM-DD format (UTC)
  endDate: z.string(), // YYYY-MM-DD format (UTC)
  teamIds: z.array(z.string()).optional(), // Optional team filter
  compareMode: z.boolean().optional(), // Enable comparison with previous period
});

export const MarketingAgentAnalyticsInputSchema: z.ZodType<MarketingAgentAnalyticsInput> =
  MarketingAgentAnalyticsInputSchema_;

// Export the underlying schema for operations like extend, omit, etc.
export { MarketingAgentAnalyticsInputSchema_ };

export interface MarketingAgentAnalyticsInput
  extends z.infer<typeof MarketingAgentAnalyticsInputSchema_> {}

// Common metric with comparison
const MetricWithComparisonSchema_ = z.object({
  value: z.number(),
  percentageChange: z.number().optional(), // Only present when compareMode=true
});

export const MetricWithComparisonSchema: z.ZodType<MetricWithComparison> =
  MetricWithComparisonSchema_;

export interface MetricWithComparison
  extends z.infer<typeof MetricWithComparisonSchema_> {}
